import { styled } from '@mui/material/styles';

import EmptyBasketImageBase from '@/assets/empty-basket.svg';

export const EmptyBasketImage = styled(EmptyBasketImageBase)(() => ({
  width: 93,
  height: 'auto',
}));
